interface ContentUpdatingManager {
    setAstroPrognosisDataLastUpdating: (date: Date) => void;
    getAstroPrognosisDataLastUpdating: () => Date | null;
    setZodiacPrognosisDataLastUpdating: (date: Date) => void;
    getZodiacPrognosisDataLastUpdating: () => Date | null;
    setYearPrognosisDataLastUpdating: (date: Date) => void;
    getYearPrognosisDataLastUpdating: () => Date | null;
    clearAllDataLastUpdating: () => void;
}

const ASTRO_PROGNOSIS_DATA_LAST_UPDATING_KEY = 'astroPrognosisDataLastUpdating';
const ZODIAC_PROGNOSIS_DATA_LAST_UPDATING_KEY = 'zodiacPrognosisDataLastUpdating';
const YEAR_PROGNOSIS_DATA_LAST_UPDATING_KEY = 'yearPrognosisDataLastUpdating';

export const contentUpdatingManager: ContentUpdatingManager = {

    setAstroPrognosisDataLastUpdating: (date: Date) => {
        localStorage.setItem(ASTRO_PROGNOSIS_DATA_LAST_UPDATING_KEY, date.toISOString());
    },

    getAstroPrognosisDataLastUpdating: (): Date | null => {
        const date = localStorage.getItem(ASTRO_PROGNOSIS_DATA_LAST_UPDATING_KEY);
        return date ? new Date(date) : null;
    },

    setZodiacPrognosisDataLastUpdating: (date: Date) => {
        localStorage.setItem(ZODIAC_PROGNOSIS_DATA_LAST_UPDATING_KEY, date.toISOString());
    },

    getZodiacPrognosisDataLastUpdating: (): Date | null => {
        const date = localStorage.getItem(ZODIAC_PROGNOSIS_DATA_LAST_UPDATING_KEY);
        return date ? new Date(date) : null;
    },

    setYearPrognosisDataLastUpdating: (date: Date) => {
        localStorage.setItem(YEAR_PROGNOSIS_DATA_LAST_UPDATING_KEY, date.toISOString());
    },

    getYearPrognosisDataLastUpdating: (): Date | null => {
        const date = localStorage.getItem(YEAR_PROGNOSIS_DATA_LAST_UPDATING_KEY);
        return date ? new Date(date) : null;
    },

    clearAllDataLastUpdating: () => {
        localStorage.removeItem(ASTRO_PROGNOSIS_DATA_LAST_UPDATING_KEY);
        localStorage.removeItem(ZODIAC_PROGNOSIS_DATA_LAST_UPDATING_KEY);
        localStorage.removeItem(YEAR_PROGNOSIS_DATA_LAST_UPDATING_KEY);
    },
}
